import moment from 'moment-timezone';
import useLocalStorage from './useLocalStorage';

export default function useJobsTableTimezone(): [string, (newTimezone: string) => void] {
  return useLocalStorage('JOBS_TABLE_TIME_ZONE', moment.tz.guess() || ('America/New_York' as any));
}
